import type { FunctionComponent } from 'react';

import Icon, { ICONS } from '../../icons/icon';
import CheckboxFieldWrapper from '../../ui/forms/field_wrappers/checkbox/checkbox';

import styles from './uploader_reflect_directories_checkbox.module.css';

type Props = {
  reflectDirectories: boolean;
  onReflectDirectoriesChange: (value: boolean | undefined) => void;
};

const LabelComponent = () => (
  <Icon icon={ICONS.Collection} className={styles.icon} size={20} />
);

const UploaderReflectDirectoriesCheckbox: FunctionComponent<Props> = (
  props,
) => (
  <CheckboxFieldWrapper
    className={styles.reflect_directories}
    name="reflect_directories"
    value={props.reflectDirectories}
    onChange={props.onReflectDirectoriesChange}
    labelComponent={LabelComponent}
    help="The folder structure on disk will be created as collections"
  />
);

export default UploaderReflectDirectoriesCheckbox;
